<app-header [logoImg]="logoImg" stickyLogoImg="../../../assets/imgs/logo/se2in_logo_textwhite.png" [stickyHeaderWhite]="true"></app-header>
<app-auth [loginForm]="loginForm" (commit)="login()">
    <div header class="button-text">
        {{ 'LOGIN_PAGE_TITLE' | translate }}
    </div>
    <div body>
        <div class="form-group-right" (click)="forgetPassword()">
            <span class="primary-text">
                {{ 'LOGIN_FORGOT_PASSWORD' | translate }} ?
            </span>
        </div>
        <hr class="item-line-between">
        <span class="form-group-center">
            <p>{{ 'LOGIN_ARE_YOU_NEW' | translate }}
                <a class="ms-2" (click)="register()">{{ 'LOGIN_REGISTRATION' | translate }}</a>
            </p>
        </span>
    </div>
    <div keycloak-login class="sigin-with" style="margin: 1rem 0;">
        <div class='signin-with-header'>
            <hr class="signin-line">
            <span>{{"SIGN_IN_WITH" | translate}}</span>
            <hr class="signin-line">
        </div>
        <div class="signin-with-buttons">
            <button (click)="loginWith('google')" class='signin-with-btn' >
                <img src='../../../assets/images/signin/google.svg' class='signin-img'>
                Google
            </button>
            <button (click)="loginWith('facebook')" class='signin-with-btn' >
                <img src='../../../assets/images/signin/facebook.svg' class='signin-img'>
                Facebook
            </button>
            <button (click)="loginWith('apple')" class='signin-with-btn' >
                <img src='../../../assets/images/signin/apple.svg' class='signin-img'>
                Apple
            </button>
        </div>
    </div>
</app-auth>
<app-footer></app-footer>
